import MAP_STYLE from "../../../utils/map-style-basic-v8.json";
import { Button, Form, Input, Select } from "antd";
import _, { debounce } from "lodash";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { authenticateToken } from "../../../utils/auth";
import { responseNotification } from "../../../utils/notify";
import { useParams } from "react-router";
import axios from "axios";
import ReactMapGL, {
  FlyToInterpolator,
  FullscreenControl,
  GeolocateControl,
  Marker,
  NavigationControl,
} from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";
const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_API_KEY; // Set your mapbox token here
function getCursor({ isHovering, isDragging }) {
  return isDragging ? "grabbing" : isHovering ? "pointer" : "default";
}
const { Option } = Select;

const AddSupplier = ({ visibleData, onCloseMethod }: any) => {
  const route = useParams();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [supplierData, setSupplierData] = useState(undefined);
  const [error, setError] = useState("");
  const [key, setKey] = useState<string>();

  const [locationOptions, setLocationOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [currentLocation, setCurrentLocation] = useState({
    lat: 23.77340239600077,
    lng: 90.41329051290532,
  });
  const mapContainerRef = useRef(null);

  // **************************************
  const [viewport, setViewport] = React.useState({
    container: mapContainerRef.current,
    latitude: currentLocation?.lat,
    longitude: currentLocation?.lng,
    width: "100%",
    height: "380px",
    zoom: 13,
    pitch: 50,
    bearing: 0,
    clickRadius: 50,
    getMapCenterByLngLatPosition: [currentLocation?.lng, currentLocation?.lat],
    center: [currentLocation?.lng, currentLocation?.lat],
    initialCenterCoordinate: [currentLocation?.lng, currentLocation?.lat],
  });
  // **************************************

  // ******************************
  const getLocationOptions = useCallback(async (key?: string) => {
    setLocationOptions({ loading: true, list: [] });
    const encodedUri = `${process.env.REACT_APP_MAP_API}`;
    const res = await axios.get(
      `${encodedUri}/autocomplete` + (key ? `?key=${key}` : ``),
      {
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
        },
      }
    );

    setLocationOptions({
      loading: false,
      list: res?.data?.places,
    });
  }, []);

  useEffect(() => {
    form.resetFields(["latitude", "longitude"]);
  }, [currentLocation]);

  // ******************************
  const onSubmit = async (data) => {
    setLoading(true);

    const readyData = data && {
      name: data.name,
      mobileNumber: data.mobileNumber,
      address: data.address,
      shopId: (route as any).shopId,
      location: {
        latitude: data.latitude,
        longitude: data.longitude,
      },
    };

    if (supplierData) {
      await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/supplier`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...readyData,
          id: visibleData?.id,
          deleted: false,
          mobileNumber: `+88${data?.mobileNumber}`,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);

          if (res.statusCode === 200) {
            responseNotification("Supplier Updated Successfully", "success");
            form.resetFields();
            if (onCloseMethod) {
              onCloseMethod();
            }
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          setLoading(false);
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    } else {
      await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/supplier`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...readyData,
          mobileNumber: `+88${data?.mobileNumber}`,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);

          if (res.statusCode === 200) {
            responseNotification("Supplier Create Successfully", "success");
            form.resetFields();
            if (onCloseMethod) {
              onCloseMethod();
            }
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          setLoading(false);
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };

  useEffect(() => {
    if (visibleData) {
      setSupplierData(visibleData);
    }
  }, [visibleData]);

  useEffect(() => {
    if (key) {
      getLocationOptions();
    }
  }, [getLocationOptions]);

  useEffect(() => {
    if (supplierData) {
      form.resetFields(Object.keys(visibleData));
      setCurrentLocation({
        lat: supplierData?.location.latitude,
        lng: supplierData?.location.longitude,
      });
    }
  }, [supplierData]);

  useEffect(() => {
    setViewport({
      container: mapContainerRef.current,
      latitude: currentLocation?.lat,
      longitude: currentLocation?.lng,
      width: "100%",
      height: "380px",
      zoom: 13,
      pitch: 50,
      bearing: 0,
      clickRadius: 50,
      getMapCenterByLngLatPosition: [
        currentLocation?.lng,
        currentLocation?.lat,
      ],
      center: [currentLocation?.lng, currentLocation?.lat],
      initialCenterCoordinate: [currentLocation?.lng, currentLocation?.lat],
    });
  }, [currentLocation]);

  const fetchRef = useRef(0);
  const handleSearch = React.useMemo(() => {
    const loadOptions = (value: string, field: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }

      if (value) {
        if (field === "locations") getLocationOptions(value);
      }
    };

    return debounce(loadOptions, 1200);
  }, [getLocationOptions]);

  return (
    <div className="add-product drawer-toggle-wrapper">
      <div className="drawer-toggle-inner-wrapper">
        <Form
          name="control-hooks"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          className="ant-form ant-form-vertical"
          onFinish={onSubmit}
          form={form} // like ref
          layout="vertical"
          initialValues={{
            ...supplierData,
            mobileNumber: visibleData?.mobileNumber?.replace("+88", ""),
          }}
        >
          <Form.Item
            hasFeedback
            label="Supplier Name"
            rules={[
              {
                required: true,
                message: "Supplier Name is Required!",
              },
            ]}
            name="name"
          >
            <Input id="name" type="text" placeholder="Enter Supplier Name" />
          </Form.Item>

          <Form.Item
            hasFeedback
            label="Mobile Number"
            rules={[
              {
                required: true,
                message: "Mobile Number is required!",
              },
              {
                validator: async (_, names) => {
                  if (!names?.match(/(^(01){1}[3456789]{1}(\d){8})$/)) {
                    return Promise.reject(
                      new Error("Enter valid mobile number")
                    );
                  }
                },
              },
            ]}
            name="mobileNumber"
            style={{ minWidth: "98%" }}
          >
            <Input
              id="mobile"
              type="mobile"
              addonBefore={"+88"}
              placeholder="Enter Mobile Number"
            />
          </Form.Item>

          <Form.Item
            hasFeedback
            label="Address"
            name="address"
            style={{ minWidth: "98%" }}
          >
            <Select
              allowClear
              autoClearSearchValue={false}
              showSearch
              placeholder="Select Address"
              optionFilterProp="children"
              onSearch={(val) => {
                handleSearch?.(val, "locations");
              }}
              onSelect={(val) => {
                const matchData = locationOptions?.list?.find(
                  (place) => val === place.address
                );

                setCurrentLocation({
                  lat: matchData?.location?.latitude,
                  lng: matchData?.location?.longitude,
                });
              }}
              filterOption={(input, option) =>
                option.children
                  .toString()
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {locationOptions?.list?.map((place) => (
                <Option value={place?.address} key={place?.id}>
                  {place?.address}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            hasFeedback
            label="Latitude"
            name="latitude"
            initialValue={currentLocation?.lat}
          >
            <Input id="latitude" type="text" placeholder="23.86450" />
          </Form.Item>

          <Form.Item
            hasFeedback
            label="Longitude"
            name="longitude"
            initialValue={currentLocation?.lng}
          >
            <Input id="longitude" type="text" placeholder="90.53680" />
          </Form.Item>

          <ReactMapGL
            mapboxApiAccessToken={MAPBOX_TOKEN}
            {...viewport}
            getCursor={getCursor}
            mapStyle={MAP_STYLE}
            onViewportChange={(viewport) => setViewport(viewport)}
            transitionInterpolator={new FlyToInterpolator()}
            // onDblClick={}
          >
            <Marker
              latitude={currentLocation?.lat}
              longitude={currentLocation?.lng}
              offsetLeft={(-viewport.zoom * 1.0) / 2}
              offsetTop={(-viewport.zoom * 3) / 2}
              draggable
              onDragEnd={(e) => {
                setCurrentLocation({
                  lat: e?.lngLat?.[1],
                  lng: e?.lngLat?.[0],
                });
              }}
            >
              <svg
                width={viewport.zoom * 1.5}
                height={viewport.zoom * 2}
                viewBox="0 0 16 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.78524 0C3.49244 0 0 3.49247 0 7.78524C0 9.87295 1.25608 12.4731 3.73326 15.5133C5.5422 17.7335 7.32281 19.3443 7.3977 19.4118L7.78524 19.761L8.17278 19.4118C8.24766 19.3443 10.0283 17.7335 11.8372 15.5133C14.3144 12.4731 15.5705 9.87295 15.5705 7.78524C15.5705 3.49247 12.078 0 7.78524 0V0Z"
                  fill="#CD113B"
                />
                <path
                  d="M7.88383 11.7769C10.0337 11.7769 11.7764 10.0342 11.7764 7.88432C11.7764 5.73448 10.0337 3.9917 7.88383 3.9917C5.734 3.9917 3.99121 5.73448 3.99121 7.88432C3.99121 10.0342 5.734 11.7769 7.88383 11.7769Z"
                  fill="white"
                />
              </svg>
            </Marker>
            <GeolocateControl
              style={{ right: 10, top: 10 }}
              positionOptions={{ enableHighAccuracy: true }}
              trackUserLocation={true}
              // auto
              label="Current Location"
            />
            <FullscreenControl style={{ right: 10, top: 50 }} />
            <NavigationControl style={{ right: 10, top: 90 }} />
          </ReactMapGL>

          <div className="buttons-container">
            <Button
              disabled={loading || !!error}
              loading={(loading ? "loading" : undefined) as any}
              type="primary"
              htmlType="submit"
              className="add-submit-btn text-center mr-2"
            >
              Submit
            </Button>
            <Button
              type="ghost"
              htmlType="button"
              onClick={() => {
                form?.resetFields();
              }}
              className="reset-submit-btn text-center mr-2"
            >
              Reset
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default AddSupplier;
